import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

const dialog = [
  new Dialog(
    "SONNY: Ambrose old boy! I feel like a nice cold brew.What’s good on tap?",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-192-Sonny-1-MP3.mp3")
  ),
  new Dialog(
    "AMBROSE : Nothing anymore I’m afraid Sonny Yang.This pandemic has forced me to close the Bemused Horseman for good.",
    require("@/images/Bartender.png"),
    require("@/audio/Pandemic-192-Bartender-1-MP3.mp3")
  ),
  new Dialog(
    "SONNY: Oh Ambrose, I had no idea. I’m so sorry…",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-192-Sonny-2-MP3.mp3")
  ),
  new Dialog(
    "AMBROSE: If I had only known it would come to this, I could have prepared for the worst or done something. I feel so hopeless…",
    require("@/images/Bartender.png"),
    require("@/audio/Pandemic-192-Bartender-2-MP3.mp3")
  ),
  new Dialog(
    "SONNY: Don’t blame yourself Ambrose.Blame the failed socio - political systems which allowed the pandemic to happen as disastrously as it did in the first place.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-192-Sonny-3-MP3.mp3")
  ),
  new Dialog(
    "AMBROSE: I read in the papers that the YOGID virus was created by Communist dairy farmers in a secret laboratory! I always knew those bastards were up to no good!",
    require("@/images/Bartender.png"),
    require("@/audio/Pandemic-192-Bartender-3-MP3.mp3")
  ),
  new Dialog(
    "SONNY: … Ambrose I’ll be honest, I never liked the Bemused Horseman.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-192-Sonny-4-MP3.mp3")
  ),
];

export class BelovedOldPub extends Scene {
  async init() {
    this.title = "Beloved Old Pub";
    this.image = require("@/images/Vincent_Scotto.png");
    this.description = "";
    this.audio = null;
  }

  get options() {
    return [
      new Choice("Enter Pub", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description = "SONNY YANG: I need to find that SANITIZER!";
          this.audio = require("@/audio/Pandemic-182-Sonny-MP3.mp3")
        } else {
          await this.dialogRunner(dialog)
          this.init();
        }
      }),
      new Choice("Go Left", async () => await this.navigate(scenes.BankExterior())),
      new Choice("Go Right", async () => await this.navigate(scenes.HouseExterior())),
    ];
  }
}

export default new BelovedOldPub();
